<template>
  <div ref="TotalExperienceChart">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="container-section-header mt-1 mb-0">
        {{ title }}
      </h3>
      <router-link
        :to="{
          name: surveyType == 'RED' ? 'ViewAllSurveysRed' : 'ViewAllSurveysYes',
        }"
        class="d-flex align-items-center cursor-pointer"
      >
        <p class="view-all m-0 pe-2">Detailed Overview</p>
      </router-link>
      <!-- <span
        @click="downLoadChart('Total-Experience-Chart', 'TotalExperienceChart')"
        >Download This Chart</span
      > -->
    </div>

    <section class="my-4">
      <div class="p-4 text-white container-section w-100">
        <div class="d-flex justify-content-between">
          <filter-ui v-if="years.length > 1">
            <template v-slot:filterOptions v-if="totalExperienceData">
              <div
                v-for="(item, index) in years"
                :key="'main-stats' + item + index + surveyType"
              >
                <input
                  class="d-none"
                  type="radio"
                  :id="`${index}-${item}-${surveyType}`"
                  :value="item"
                  v-model="selectedYear"
                />

                <label
                  class="me-2 text-capitalize filter-button px-3"
                  :for="`${index}-${item}-${surveyType}`"
                  >{{ item }}</label
                >
              </div>
            </template>
          </filter-ui>

          <div class="d-flex" v-if="surveyType === 'RED'">
            <div v-for="quarter in quarters" :key="`quarter-${quarter.id}`">
              <input
                class="d-none"
                type="radio"
                :id="`main-stats${quarter.id}-${surveyType}`"
                :value="quarter.id"
                v-model="selectedQuarter"
              />

              <label
                class="me-2 text-capitalize filter-button px-3"
                :for="`main-stats${quarter.id}-${surveyType}`"
                >{{ quarter.name }}</label
              >
            </div>
          </div>
        </div>
        <!--  total-experience-chart -->
        <div
          class=" total-experience-chart"
          :class="`total-experience-chart-${surveyType}`"
          ref="TotalExperienceChart"
        ></div>
      </div>
    </section>
  </div>
</template>

<script>
import TotalExperienceManager from "@/manager/charts/TotalExperienceManager";
import { mapGetters } from "vuex";

export default {
  name: "TotalExperience",
  props: {
    surveyType: {
      type: String,
      required: true,
    },
    totalExperienceData: {
      type: Array,
      required: true,
    },
    years: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedQuarter: null,
      selectedYear: "",
      quarters: [
        { id: "1", name: "R1" },
        { id: "2", name: "R2" },
        { id: "3", name: "R3" },
        { id: "4", name: "R4" },
      ],
    };
  },
  computed: {
    ...mapGetters("mainStats", ["getYesSelectedYear", "getRedSelectedYear"]),
  },
  methods: {
    // async downLoadChart(name, ref) {
    // 	const el = this.$refs[ref];
    // 	const options = {
    // 		type: "dataURL",
    // 	};
    // 	this.output = await this.$html2canvas(el, options);
    //
    // 	var link = document.createElement("a");
    // 	link.download = `${name}.png`;
    // 	// link.download = `${name}.JPEG`;
    // 	link.href = this.output;
    // 	link.click();
    // },
    createChart() {
      if (this.totalExperienceData.length > 0) {
        if (this.surveyType === "RED") {
          this.selectedQuarter = Math.max(
            ...[...this.totalExperienceData]
              .map((item) => +item.quarter.substring(1))
              .filter((value, index, self) => self.indexOf(value) === index)
          );
        }
        const chartContainerWidth =
          this.$refs.TotalExperienceChart?.clientWidth - 20;
        TotalExperienceManager.createChart(
          chartContainerWidth,
          this.totalExperienceData,
          this.$router,
          this.surveyType,
          this.selectedQuarter
        );
      }
    },
  },
  watch: {
    totalExperienceData(newVal, old) {
      if (newVal[0]?.surveyId != old[0]?.surveyId) {
        this.createChart();
      }
    },
    selectedQuarter(newVal, old) {
      if (old && newVal !== old) {
        const chartContainerWidth =
          this.$refs.TotalExperienceChart?.clientWidth - 20;
        TotalExperienceManager.createChart(
          chartContainerWidth,
          this.totalExperienceData,
          this.$router,
          this.surveyType,
          this.selectedQuarter
        );
      }
    },
    selectedYear(newVal, oldVal) {
      if (oldVal != "") {
        this.$emit("change-year", newVal);
      }
    },
  },
  mounted() {
    this.createChart();
    this.selectedYear =
      this.surveyType == "RED"
        ? this.getRedSelectedYear
        : this.getYesSelectedYear;
  },
};
</script>

<style lang="scss" scoped>
.total-experience-chart {
  max-height: 38rem;
  overflow-y: auto;
}
/* .quarters {
  position: relative;

  &::after {
    content: "";
    width: 100%;
    height: 1px;
    background-color: $color-white;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}

.quarter-item {
  width: 23.5%;
}

.quarter-circle {
  padding: 0.7rem;
  width: 100%;
  position: relative;
  z-index: 2;
  border-radius: $radius-30;
  transition: all 0.4s;
  border: $border-white-1;
  background-color: $color-grey-100;
}
input:checked ~ .quarter-circle {
  background-color: $color-white;
  color: $color-grey-100;
} */
.view-all {
  font-weight: $font-weight-semiBold;
  font-size: 1.5rem;
  line-height: 2rem;
}
</style>
